module.exports = __webpack_public_path__ + "static/media/successIcon (1).a53ab7f4.svg";